export const GetterTypes = {
  IS_ADMIN: 'IS_ADMIN',
  IS_SUPER_ADMIN: 'IS_SUPER_ADMIN',
  IS_LOGGED_IN: 'IS_LOGGED_IN',
  
  AUTH_TOKEN: 'AUTH_TOKEN',
};
